<script setup lang="ts">
import { useBusinessRequestFormStore } from '@/pages/index/stores/business-request-form-store';
import { defineAsyncComponent } from 'vue';
const businessRequestFormStore = useBusinessRequestFormStore()
import { navigate } from 'vike/client/router'

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
const header_image = `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-recherche-renovation.webp`

const navigateToHome = async () => {
    businessRequestFormStore.isFromArticles = true;
    await navigate("/")
};
</script>

<template>
    <Default>
            <div class="app-content content bg-white pt-5" style="min-height: 73vh; margin-left: 0px"> 
                <div class="content-wrapper container bg-white h-100 pt-0 pt-md-5">
                    <main id="main pt-5">
                        <h2 class="text-center mt-2 mt-md-5 mb-3">
                            Comment trouver une entreprise de rénovation fiable près de chez vous
                        </h2>
                        
                        <p class="text-center mb-3 sized-text">
                            Vous cherchez une <strong>entreprise de rénovation fiable</strong> pour repeindre votre salle de bain, refaire une cuisine ou moderniser votre intérieur ? Grâce à Topela, vous accédez en quelques clics à des <strong>entreprises qualifiées</strong>, disponibles près de chez vous et <strong>vérifiables en toute transparence</strong>.
                        </p>
                        <div class="d-flex justify-content-center mt-4 mb-5">
                            <button class="btn btn-info btn-text-visibility rounded-3" @click="navigateToHome">
                                Besoin d'une entreprise de rénovation ?
                            </button>
                        </div>
                        <img 
                            class="mt-2 rounded-4" 
                            :src="header_image" 
                            style="width: 100%; aspect-ratio: 16 / 5;" 
                            alt="Partnership">

                        <section>
                            <div class="row">
                                <div class="d-block d-lg-none col-lg-4 mb-5 border-black border-top-0 border-end-0 border-start-0 pb-3">
                                    <div class="row">
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Auteur :</p>
                                            <p><strong>Matteo MONDI</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Catégorie :</p>
                                            <p><strong>Conseil</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Temps de lecture :</p>
                                            <p><strong>5 minutes</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Dernière modification :</p>
                                            <p><strong>17 mai 2025</strong></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-none d-lg-block col-lg-3 mb-5">
                                    <div class="row">
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Auteur :</p>
                                            <p><strong>Matteo MONDI</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Catégorie :</p>
                                            <p><strong>Conseil</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Temps de lecture :</p>
                                            <p><strong>5 minutes</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Dernière modification :</p>
                                            <p><strong>17 mai 2025</strong></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-9 px-3 border-black border-top-0 border-end-0 border-bottom-0">
                                    <div class="">
                                        <h4 class="mb-3">
                                            Nos entreprises partenaires pour vos travaux de rénovation
                                        </h4>
                                        <p class="mb-2 sized-text">
                                            Qu’il s’agisse d’une <strong>simple remise en peinture</strong>, d’un <strong>réaménagement de salle de bain</strong>, ou d’une rénovation complète d’un logement, nous sélectionnons des entreprises de confiance, reconnues pour leur sérieux et leur savoir-faire. <br>
                                            Chaque professionnel référencé sur Topela est évalué par ses clients et respecte une <strong>charte qualité stricte</strong>.
                                        </p>
                                        <h5>
                                            Contrôle de qualité
                                        </h5>
                                        <p class="mb-2 sized-text">
                                            Tous les professionnels présents sur notre plateforme sont immatriculés à la chambre de commerce et disposent d’un <strong>numéro SIRET vérifiable</strong>.
                                        </p>

                                        <h4 class="mb-3 mt-4">
                                            Comment trouver une entreprise de rénovation ?
                                        </h4>
                                        <p class="mb-2 sized-text">
                                            Trouver une entreprise de rénovation n’a jamais été aussi simple. <br>
                                            Grâce à notre plateforme intuitive, filtrez les professionnels selon <strong>votre besoin (peinture, salle de bain, isolation, etc.)</strong> et votre <strong>localisation</strong>.
                                        </p>
                                        <h5>
                                            Engager une entreprise de rénovation via Topela
                                        </h5>
                                        <p class="sized-text">
                                            Avec Topela, vous avez <strong>deux solutions simples</strong> pour engager une entreprise :
                                        </p>
                                        <ul class="mb-3" style="list-style-type:none !important; padding-left: 0px;">
                                            <li class="no-dot">
                                                <strong>1. Publiez votre demande et laissez les entreprises vous contacter :</strong>
                                            </li>
                                            <li class="ms-5 sized-text">
                                                Déposez gratuitement votre projet sur <a href="https://123topela.fr"
                                                style="text-decoration: underline !important;color:#0070C0 !important;"
                                                target="_blank">123topela.fr</a> (ex : refaire la peinture de votre salle de bain).
                                            </li>
                                            <li class="ms-5 sized-text">
                                                Les entreprises disponibles reçoivent une notification.
                                            </li>
                                            <li class="ms-5 sized-text">
                                                Celles intéressées vous contactent directement.
                                            </li>
                                            <li class="ms-5 sized-text">
                                                Vous comparez les profils et choisissez en toute confiance.
                                            </li>
                                            <li class="ms-5 sized-text">
                                                Devis et factures sont accessibles dans votre espace sécurisé.
                                            </li>
                                            <li class="no-dot">
                                                <strong>2. Recherchez directement une entreprise dans l’annuaire :</strong>
                                            </li>
                                            <li class="ms-5 sized-text">
                                                Consultez les profils des professionnels proches de chez vous.
                                            </li>
                                            <li class="ms-5 sized-text">
                                                Comparez les services, prix et avis.
                                            </li>
                                            <li class="ms-5 sized-text">
                                                Contactez directement les entreprises qui correspondent à vos besoins.
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-4">
                                        <h4 class="mb-3">
                                            Un accompagnement complet, de A à Z
                                        </h4>
                                        <p class="mb-3 sized-text">
                                            Topela, c’est bien plus qu’un annuaire. C’est une <strong>plateforme complète</strong> pour gérer vos travaux sereinement :
                                        </p>
                                        <ul class="mb-3">
                                            <li class="sized-text">
                                                ✅ Gratuit, sans engagement
                                            </li>
                                            <li class="sized-text">
                                                ✅ Publication rapide de vos demandes
                                            </li>
                                            <li class="sized-text">
                                                ✅ Messagerie intégrée pour dialoguer avec les artisans
                                            </li>
                                            <li class="sized-text">
                                                ✅ Signature électronique des devis
                                            </li>
                                            <li class="sized-text">
                                                ✅ Suivi de l’intervention depuis votre espace personnel
                                            </li>
                                            <li class="sized-text">
                                                ✅ Réception des factures au format électronique
                                            </li>
                                            <li class="sized-text">
                                                ✅ Téléchargement facile des documents (devis, factures, PDF)
                                            </li>
                                        </ul>
                                       
                                        <h4 class="mb-3 mt-4">
                                            Ce que peut réaliser pour vous une entreprise de rénovation
                                        </h4>
                                        <p class="mb-3 sized-text">
                                            Nos partenaires peuvent prendre en charge tous vos projets de rénovation intérieure :
                                        </p>
                                        <ul class="mb-3">
                                            <li class="sized-text">
                                                <strong>Peinture</strong> (murs, plafonds, carrelage, pièces humides…)
                                            </li>
                                            <li class="sized-text">
                                                <strong>Réfection de salle de bain ou cuisine</strong>
                                            </li>
                                            <li class="sized-text">
                                                <strong>Pose de carrelage, faïence, parquet</strong>
                                            </li>
                                            <li class="sized-text">
                                                <strong>Travaux de plâtrerie, isolation, cloisons</strong>
                                            </li>
                                            <li class="sized-text">
                                                <strong>Rénovation électrique ou plomberie</strong>
                                            </li>
                                            <li class="sized-text">
                                                <strong>Rénovation complète d’appartement ou maison</strong>
                                            </li>
                                        </ul>

                                        <h4 class="mb-3 mt-4">
                                            Quand faire appel à une entreprise générale de rénovation ?
                                        </h4>
                                        <p class="mb-3 sized-text">
                                            Vous avez plusieurs types de travaux à faire (plomberie, peinture, revêtements, etc.) ? <br>
                                            Une <strong>entreprise tous corps d’état</strong> est idéale : elle gère l’ensemble du projet, coordonne les corps de métier et respecte les délais. C’est l’option parfaite pour rénover une salle de bain ou une pièce entière <strong>sans stress</strong>.
                                        </p>

                                        <h4 class="mb-3 mt-4">
                                            Tarifs des entreprises de rénovation en France
                                        </h4>
                                        <p class="mb-3 sized-text">
                                            Les prix varient selon le type de travaux, la surface à rénover, les matériaux choisis et la région :
                                        </p>
                                        <ul class="mb-2">
                                            <li class="sized-text">
                                                <strong>Peinture de salle de bain</strong> : 30–55 €/m²
                                            </li>
                                            <li class="sized-text">
                                                <strong>Rénovation complète d’une salle de bain</strong> : 5 000–10 000 € selon l’équipement
                                            </li>
                                            <li class="sized-text">
                                                <strong>Pose de carrelage</strong> : 45–70 €/m²
                                            </li>
                                            <li class="sized-text">
                                                <strong>Rénovation d’un appartement</strong> : à partir de 600 €/m² pour une rénovation standard
                                            </li>
                                        </ul>
                                        <p class="mb-3 sized-text">
                                            N’hésitez pas à demander plusieurs devis pour comparer les prix et les prestations.
                                        </p>
                                    </div>
                                    
                                    <div class="mt-3 mb-2">
                                        <h4 class="mb-3 mt-4">
                                            Demandes populaires :
                                        </h4>
                                        
                                        <ul class="" style="list-style-type:none !important; padding-left: 0px;">
                                            <li class="no-dot">
                                                Peinture de salle de bain
                                            </li>
                                            <li class="no-dot">
                                                Pose de carrelage mural
                                            </li>
                                            <li class="no-dot">
                                                Rénovation complète d’un studio
                                            </li>
                                        </ul>
                                        <div class="d-flex justify-content-start mt-3">
                                            <button class="btn btn-info btn-text-visibility rounded-3" @click="navigateToHome">
                                                Postez votre demande
                                            </button>
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <h4 class="mb-3 mt-4">
                                            Autres professions
                                        </h4>
                                        <ul class="" style="list-style-type:none !important; padding-left: 0px;">
                                            <li class="no-dot">
                                                <a href="/annuaire/search/?query=Électricien" target="_blank" style="text-decoration: underline !important;color:#0070C0 !important;">
                                                    Électricien
                                                </a>
                                            </li>
                                            <li class="no-dot">
                                                <a href="/annuaire/search/?query=Plombier" target="_blank" style="text-decoration: underline !important;color:#0070C0 !important;">
                                                    Plombier
                                                </a>
                                            </li>
                                            <li class="no-dot">
                                                <a href="/annuaire/search/?query=Carreleur" target="_blank" style="text-decoration: underline !important;color:#0070C0 !important;">
                                                    Carreleur
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
    </Default>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');
.no-dot {
    list-style-type: none !important;
    font-size: 16px !important;
}

.btn-text-visibility{
    font-size: 16px !important;
    font-weight: normal !important;
}

.sized-text {
    font-size: 16px !important;
}

.hero-background {
  height: 60vh;
  /* background-position: 25% center !important; */
  background-repeat: no-repeat !important;
  background-size: cover !important;
  margin-top: 5vh;
  position: relative;
}

ul {
  list-style-type: disc !important; /* Ensures bullets appear */
  padding-left: 20px; /* Adds space for bullets */
}

ul li {
    list-style: disc;
}

li {
  margin-bottom: 5px; /* Adds spacing between items */
}

li::marker {
  color: black !important; /* Sets bullet color to black */
  font-size: 1em; /* Adjusts bullet size (optional) */
}
</style>